import React, { useState } from 'react';
import styled from 'styled-components';
import { Refresh } from '@material-ui/icons';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { User } from '../Accounts/AccountUsersOverview';
import useHasPrivilege from './useHasPrivilege';
import usersService from '../../services/users';
import { Privilege } from '../../api';

interface Props {
  user: User;
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

interface ButtonProps {
  selected: boolean;
}

const Icon = styled.div<ButtonProps>`
  width: 24px;
  height: 24px;
  color: ${(props) => (props.selected ? '#707070' : '#F7F7F7')};
`;

const ResendInvite: React.FC<Props> = ({ user }) => {
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const enabled = useHasPrivilege(Privilege.WriteUsers);
  const onClick = (event: React.MouseEvent) => {
    if (enabled) {
      event.preventDefault();
      event.stopPropagation();
      setOpen(true);
    }
  };

  const handleClose = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setOpen(false);
  };

  const onResend = async (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setOpen(false);
    if (!enabled) return;
    try {
      await usersService.resendInvite(user.id);
      enqueueSnackbar(`Invite to ${user?.email} has been resent`, {
        variant: 'info',
        autoHideDuration: 3000,
      });
    } catch (error) {
      console.error(error);
      enqueueSnackbar(`Failed to send invite to ${user?.email}`, {
        variant: 'error',
        autoHideDuration: 3000,
      });
    }
  };
  return (
    <Container>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{'Resend invite?'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Do you want to resend the invite to '{user?.email}'?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            No
          </Button>
          <Button onClick={onResend} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Icon selected={enabled} onClick={onClick}>
        <Refresh style={{ width: '100%', height: '100%' }} />
      </Icon>
    </Container>
  );
};

export default ResendInvite;
